import React from 'react';
import {
  Box,
  Stack,
  Typography
} from '@mui/material';

import { useClientZS } from '../../pages/ClientZS';

import { ScheduleCard } from './event/ScheduleCard';
import { ResortAddressCard } from './event/ResortAddressCard';
import { PackingListCard } from './event/PackingListCard';
import { InsuranceCard } from './event/InsuranceCard';

export const EventDetails = () => {
  const { orderData, purchaserData } = useClientZS();

  if (!orderData) {
    return (
      <Typography
        variant="h5"
        textAlign="center"
      >
        Brak danych
      </Typography>
    );
  }

  return (
    <Stack
      direction={{ xs: 'column', lg: 'row' }}
      spacing={4}
      alignItems="stretch"
    >
      <Box flex={1}>
        <ScheduleCard
          orderData={orderData}
          purchaserData={purchaserData}
        />
      </Box>
      <Box flex={1}>
        <ResortAddressCard
          orderData={orderData}
        />
      </Box>
      <Box flex={1}>
        <PackingListCard
          orderData={orderData}
        />
      </Box>
      <Box flex={1}>
        <InsuranceCard orderData={orderData} />
      </Box>
    </Stack>
  );
};
